import React from 'react'

import InputContainer from './InputContainer.js'
import Select from '../Select.js'
import Toggle from '../ncss/Toggle.js'

// React select passes in bad values onBlur, and redux-form expects the value
const valueOnBlur = (props) => () => { props.onBlur(props.value) }

export default ({ label, input, options, title, meta, ...props }) => {
  return options.length > 3
    ? (
      <InputContainer label={label} meta={meta} title={title} type='select'>
        <Select {...input}
          options={options}
          onChange={option => input.onChange(option && option.value)}
          autoBlur
          openOnFocus
          onBlur={valueOnBlur(input)}
          onBlurResetsInput={false}
          {...props}
        />
      </InputContainer>
    )
    : <Toggle {...input}
      title={title}
      options={options}
      label={label}
    />
}



// WEBPACK FOOTER //
// ./client/src/components/forms/Select.js